export default __webpack_public_path__ + "static/media/fabian.88266161.png";